<script setup>
import { Icon } from '@iconify/vue'
const props = defineProps(['icon'])
</script>

<template>
  <Icon :icon="`${props.icon[0]}:${props.icon[1]}`" />
</template>
